import React, { createContext, useReducer, useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// redux
import { getHeaderVisibility, getDarkHeader } from "frontend/store/layout";

// config
import getDefaultState from "../context/stateHelpers/getDefaultState";
import getAuthMenuVisibility from "../context/getAuthMenuVisibility";

// store
import { reducer } from "../context/store";

// context
import { useAuth } from "frontend/hooks/useAuth";
import { useViewport } from "js/hooks/useViewport";

// components
import MountingWrapper from "../components/MountingWrapper";

/*---------------------------
| Context
---------------------------*/
export const SiteHeaderContext = createContext();
SiteHeaderContext.displayName = "SiteHeader"; // Display Name

// component
export const SiteHeaderProvider = ({
    children,
    isDarkMode = false,
    currentPage,
    ssrCookies = {},
    isLegacyPage = false
}) => {
    const viewport = useViewport();
    const { isLoggedIn, currentUser, confirmAuth, isLoading } = useAuth() || {};
    const authMenuVisibilitiy = getAuthMenuVisibility(currentUser);

    const isDarkModeRtk = useSelector(getDarkHeader);
    const isVisible = useSelector(getHeaderVisibility);

    const nonStateProps = {
        viewport,
        currentPage,
        isDarkMode: isDarkModeRtk || isDarkMode,
        isLoggedIn,
        isLoading,
        currentUser,
        confirmAuth,
        authMenuVisibilitiy,
        isLegacyPage,
        isVisible
    };

    const stateProps = getDefaultState({
        currentPage,
        isLoggedIn,
        currentUser,
        ssrCookies
    });

    // Whatever you want to manage as internal state
    const [state, dispatch] = useReducer(reducer, stateProps);

    // useMemo so it does not pass value on every render
    const value = useMemo(() => ({ state, dispatch, nonStateProps }), [
        state,
        dispatch,
        nonStateProps
    ]);

    return (
        <SiteHeaderContext.Provider value={value}>
            <MountingWrapper>{children}</MountingWrapper>
        </SiteHeaderContext.Provider>
    );
};

export default SiteHeaderProvider;

// prop-types
const inputElementInstance =
    typeof HTMLInputElement !== "undefined" ? HTMLInputElement : () => {};

SiteHeaderProvider.propTypes = {
    children: PropTypes.any,
    isDarkMode: PropTypes.bool,
    currentPage: PropTypes.string,
    ssrCookies: PropTypes.object,
    isLegacyPage: PropTypes.bool
};
